module.exports = __webpack_public_path__ + "static/media/user.8ad8d55a.png";